import { Component, OnInit } from '@angular/core';
import { UserAccessModel } from "./shared/models/user-access.model";
import { AuthService } from "./shared/services/auth.service";
import { environment } from "../environments/environment";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'CarrierPortal';
  isAuth: boolean;
  hasAccess: boolean;
  user: UserAccessModel;
  isLoading = false;


  public constructor(private authService: AuthService) { }

  private pwdRegexp: RegExp = /The\+user\+has\+forgotten\+their\+password/gi;
  private pwdCancelRegexp: RegExp = /The\+user\+has\+cancelled\+entering\+self-asserted/gi;

  ngOnInit(): void {
    this.isLoading = true;
    this.redirectForgotPassword();
    this.setTheme();
    this.authService.implicitFlow();
    this.authService.isAuthenticated.subscribe(authStatus => {
      this.isAuth = authStatus;
      if (authStatus) {
        this.authService.getUserAccess().subscribe({
          next: userInfo => {
            this.isLoading = false;
            this.authService.carrierID = userInfo.customerId;
            this.authService.userInfo.next(userInfo);
          },
          error: () => {
            this.isLoading = false;
          }
        });
      }
    });

    this.authService.userInfo.subscribe(userInfo => {
      this.user = userInfo;
    });
  }

  private setTheme(): void {
    const isLightTheme = localStorage.getItem('lightTheme');

    if (isLightTheme && isLightTheme === 'true') {
      this.authService.switchMode(true);
    } else if (isLightTheme && isLightTheme === 'false'){
      this.authService.switchMode(false);
    } else {
      this.authService.switchMode(true);
    }
  }

  private redirectForgotPassword(): void {
    const url = window.location.href;
    if (url.search(this.pwdRegexp) !== -1) {
      window.open(environment.oidc.pwdResetURL, '_self');
    } else if (url.search(this.pwdCancelRegexp) !== -1) {
      window.open(environment.oidc.allowedURLs[1], '_self');
    }
  }

}
